export const APP_ID = "backend";
export const APP_SECURITY = "frontend";

export const BASE_URI = "/api/admin";

export const OPEN_URI = "/api/open";

export const UPLOAD_URL = BASE_URI + "/document/serve/";
export const SERVERURL = BASE_URI + "/document/upload";
